import Chart from 'chart.js/auto'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { OA_TYPES_BG_COLORS } from './config';

export default class PieChartOAShare {

  constructor(elementId, data) {
    this.elementId = elementId;

    const oa_share = data.find((elem) => elem["_id"] === "Open Access").count
    const pubs_total = data.find((elem) => elem["_id"] === "Total").count

    this.data = [
      Math.round((pubs_total - oa_share) / pubs_total * 100.0),
      Math.round((oa_share/pubs_total) * 100.0)
    ]

    this.addGraph()
  }

  addGraph() {
    const data = {
      labels: [
        'Closed Access',
        'Open Access',
      ],
      datasets: [{
        data: this.data,
        backgroundColor: [
          OA_TYPES_BG_COLORS["Closed Access"],
          OA_TYPES_BG_COLORS["Open Access"]
        ],
        hoverOffset: 4
      }]
    };

    new Chart(
      document.getElementById(this.elementId),
      {
        plugins: [ChartDataLabels],
        type: 'pie',
        data: data,
        options: {
          plugins: {
            datalabels: {
              color: '#fff',
              font: {
                size: 16,
              },
              formatter: function(value, context) {
                return value + '%';
              },
            }
          }
        }
      }
    );
  }
}
